import styled from 'styled-components';
import {
  Panel as commonPanel,
  Logobox as commonLogobox,
  Logo as commonLogo,
  Textbox as commonTextbox,
  Text as commonText,
  Form as commonForm,
  Linkbox as commonLinkbox,
} from '../../assets/Common/SignPanel.style';

import {
  Inputbox as commonInputbox,
  Input as commonInput,
  InputError as commonInputError,
} from '../../assets/Common/Inputbox.style';

import {
  Checkbox as commonCheckbox,
  Checkmark as commonCheckmark,
  Check as commonCheck,
} from '../../assets/Common/SignCheckbox.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

import { Strong as commonStrong } from '../../assets/Common/Strong.style';

export const Panel = styled.div`
  ${commonPanel}
`;

export const Logobox = styled.div`
  ${commonLogobox}
`;

export const Logo = styled.img`
  ${commonLogo}
`;

export const Textbox = styled.div`
  ${commonTextbox}
`;

export const Text = styled.div`
  ${commonText}
`;

export const Form = styled.form`
  ${commonForm}
`;

export const Inputbox = styled.div`
  ${commonInputbox}
`;

export const Input = styled.input`
  ${commonInput}
`;

export const InputError = styled.span`
  ${commonInputError}
`;

export const Checkbox = styled.div`
  ${commonCheckbox}
  margin-bottom: 25px;
`;

export const Checkmark = styled.input`
  ${commonCheckmark}
`;

export const Check = styled.label`
  ${commonCheck}
`;

export const SubmitButton = styled.button`
  ${commonButton}
`;

export const Strong = styled.strong`
  ${commonStrong}
`;

export const Linkbox = styled.div`
  ${commonLinkbox}
`;
